export const waiverContants = {
    RESET: 'RESET',
    WAIVER_FETCHING: 'WAIVER_FETCHING',
    WAIVER_FETCHED: 'WAIVER_FETCHED',
    WAIVER_SUBMITTING: 'WAIVER_SUBMITTING',
    WAIVER_SUBMITTED: 'WAIVER_SUBMITTED',
    SEARCH_BOOKING_WAYBILL: 'SEARCH_BOOKING_WAYBILL',
    GET_WAIVERED_LIST: 'GET_WAIVERED_LIST',
    GET_WAIVER_BY_ID: 'GET_WAIVER_BY_ID',
    GET_WAIVERED_ENDORSER_LIST: 'GET_WAIVERED_ENDORSER_LIST',
}